import styled, { css } from 'styled-components';

import Checkbox from '../Checkbox';

export const StyledLabel = styled.label<{
  disabled?: boolean;
  readOnly?: boolean;
  horizontal?: boolean;
  noBox?: boolean;
}>`
  display: flex;
  cursor: ${({ disabled, readOnly }) => (disabled || readOnly) ? 'default' : 'pointer'};
  margin-bottom: 16px;

  ${({ horizontal, noBox }) => !horizontal && noBox && css`
    &:last-child {
      margin-bottom: 0;
    }    
  `}

  ${({ disabled, theme }) => disabled && css`
      color: ${theme.colors.shadowGray2};
  `};

  ${({ disabled, readOnly }) => !disabled && !readOnly && css`
    &:hover {
      ${StyledLabelText} {
        color: ${({ theme }) => theme?.RadioItem?.hoverColor};
      }

      ${Checkbox.StyledCheckbox} {
        border-color: ${({ theme }) => theme?.Checkbox?.hoverOutlineColor};
      }
    }
  `}
`;

export const StyledCheckboxWrapper = styled.span`
  line-height: 0;
`;

export const StyledLabelText = styled.span<{
  horizontal?: boolean;
}>`
  display: flex;
  align-items: start;
  position: relative;
  top: 1px;
  padding-left: ${({ theme }) => theme.CheckboxItem?.labelTextPaddingLeft}px;

  ${({ horizontal }) => horizontal && css`
    padding-right: 40px;
  `}
`;
